<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">MyToken设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>币种设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create-currency @refresh="list"></create-currency>
      </div>
      <currency-list @refresh="list"></currency-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions } from 'vuex';
import CurrencyList from './components/list';
import CreateCurrency from './components/create';

export default {
  name: 'MyTokenCurrency',
  components: {
    CurrencyList,
    CreateCurrency
  },
  methods: {
    ...mapActions('myTokenCurrency', ['list'])
  },
  created() {
    this.list();
  }
};
</script>

<style lang="less" scoped></style>
